import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import { BackButton } from "@/components/button";
import { ServiceProviderRequestsTab } from "./components";

const ServiceProviderRequests = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <div className="flex flex-wrap items-center gap-3">
                <BackButton customBackPath="/service-management" />
                <div>
                  <ToolbarPageTitle text="Service Provider Requests" />
                  <ToolbarDescription>
                    Manage incoming service provider requests here.
                  </ToolbarDescription>
                </div>
              </div>
            </ToolbarHeading>
          </Toolbar>

          <div className="mt-6">
            <ServiceProviderRequestsTab />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export { ServiceProviderRequests };
